import React, { useState, useRef, useEffect } from "react";
import { TextField, Grid, InputLabel, FormControl, Select, MenuItem, FormControlLabel, Checkbox, TextareaAutosize, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Dialog, DialogTitle, DialogContent, IconButton } from '@mui/material';
import "bootstrap/dist/css/bootstrap.min.css";
import CloseIcon from '@mui/icons-material/Close';
import AccountMasterHelp from "../../../Helper/AccountMasterHelp";
import GSTRateMasterHelp from "../../../Helper/GSTRateMasterHelp";
import ItemMasterHelp from "../../../Helper/SystemmasterHelp";
import BrandMasterHelp from "../../../Helper/BrandMasterHelp";
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";
import ActionButtonGroup from "../../../Common/CommonButtons/ActionButtonGroup";
import NavigationButtons from "../../../Common/CommonButtons/NavigationButtons";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import EWayBillReport from "../../../Common/EwaybillNEInvoice/Ewaybill/EwayBillPrint";
import { useRecordLocking } from '../../../hooks/useRecordLocking';
import "./GulSaleReturn.css"
import AddButton from "../../../Common/Buttons/AddButton";
import EditButton from "../../../Common/Buttons/EditButton";
import DeleteButton from "../../../Common/Buttons/DeleteButton";
import OpenButton from "../../../Common/Buttons/OpenButton";
import UserAuditInfo from "../../../Common/UserAuditInfo/UserAuditInfo";
import SaveUpdateSpinner from "../../../Common/Spinners/SaveUpdateSpinner";
import Swal from "sweetalert2";
import EwayBillGeneration from "../../../Common/EwaybillNEInvoice/Ewaybill/EwayBillGeneration";
import EInvoiceGeneration from "../../../Common/EwaybillNEInvoice/EInvoiceGenerationProcess/EInvoiceGeneration";
import DetailAddButtom from "../../../Common/Buttons/DetailAddButton";
import DetailCloseButton from "../../../Common/Buttons/DetailCloseButton";
import DetailUpdateButton from "../../../Common/Buttons/DetailUpdateButton";
import { OutwordPostDateRecordLock } from "../../../Common/PostDateLock/PostDateRangeCheck"
import { validateDocumentDate } from "../../../Common/ValidateDateRange/ValidateDateRange"
import formatTruckNumber from "../../../Common/FormatFunctions/FormatTruckNumber"
// import GulCustomizeSBReport from "./GulSaleBillReport";
// import GulCustomizeSBBatchReport from "./GullSaleBillBatchReport";
import { formatReadableAmount } from "../../../Common/FormatFunctions/FormatAmount";

//Global Variables
var newSaleid = "";
var partyName = "";
var partyCode = "";
var unitName = "";
var unitCode = "";
var brokerName = "";
var brokerCode = "";
var itemName = "";
var item_Code = "";
var gstrate = "";
var gstRateCode = "";
var gstName = "";
var brandName = "";
var brandCode = "";
var transportName = "";
var transportCode = "";
var billToName = "";
var billToCode = "";
var selectedfilter = "";
var PartyMobNo = "";
var TransportMobNo = "";
var UnitMobNo = "";
var millgstno = "";
var newGodownCode = ''
var lblGodownName = ''


// Common style for all table headers
const headerCellStyle = {
    fontWeight: "bold",
    backgroundColor: "#3f51b5",
    color: "white",
    padding: "6px",
    textAlign: "center",
    "&:hover": {
        backgroundColor: "#303f9f",
        cursor: "pointer",
    },
};

//API URL
const API_URL = process.env.REACT_APP_API;

const GullSaleBillReturn = () => {

    //GET Values from session
    const companyCode = sessionStorage.getItem("Company_Code");
    const Year_Code = sessionStorage.getItem("Year_Code");
    const Outword_Date = sessionStorage.getItem("Outword_Date")
    const Post_Date = sessionStorage.getItem("Post_Date")
    const username = sessionStorage.getItem("username");
    const TCSApplicable = sessionStorage.getItem("TCSApplicable");
    const User_Id = sessionStorage.getItem("User_ID");

    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const navigatedRecord = searchParams.get('navigatedRecord');
    const permissions = location.state?.permissionsData;

    //State Management
    const [users, setUsers] = useState([]);
    const [showPopup, setShowPopup] = useState(false);
    const [popupMode, setPopupMode] = useState("add");
    const [selectedUser, setSelectedUser] = useState({});
    const [deleteMode, setDeleteMode] = useState(false);
    const [itemCode, setItemCode] = useState("");
    const [item_Name, setItemName] = useState("");
    const [brand_code, setBrandCode] = useState("");
    const [brand_name, setBrandName] = useState("");
    const [itemCodeAccoid, setItemCodeAccoid] = useState("");
    const [formDataDetail, setFormDataDetail] = useState({
        narration: "",
        Packing: 50,
        Quantity: 0.0,
        Netkg: 0,
        DrCr: "C" || "",
        item_Amount: 0.00,
    });


    const drCrLabel = (v) => {
        const val = (v || "").toString().trim().toUpperCase();
        if (val === "C") return "Credit";
        if (val === "D") return "Debit";
        return "";
    };

    //Head Section State Managements
    const [addOneButtonEnabled, setAddOneButtonEnabled] = useState(false);
    const [saveButtonEnabled, setSaveButtonEnabled] = useState(true);
    const [cancelButtonEnabled, setCancelButtonEnabled] = useState(true);
    const [editButtonEnabled, setEditButtonEnabled] = useState(false);
    const [deleteButtonEnabled, setDeleteButtonEnabled] = useState(false);
    const [backButtonEnabled, setBackButtonEnabled] = useState(true);
    const [isEditMode, setIsEditMode] = useState(false);
    const [highlightedButton, setHighlightedButton] = useState(null);
    const [cancelButtonClicked, setCancelButtonClicked] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [lastTenderDetails, setLastTenderDetails] = useState([]);
    const [lastTenderData, setLastTenderData] = useState({});
    const [formErrors, setFormErrors] = useState({});
    const [isChecked, setIsChecked] = useState(false);
    const [gstNo, setGstNo] = useState("");
    const [isHandleChange, setIsHandleChange] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isOpenEInvoice, setIsOpenEInvoice] = useState(false);
    const [isOpenEwayBill, setIsOpenEwayBill] = useState(false);

    const [billToManuallySet, setBillToManuallySet] = useState(false);
    const [shipToManuallySet, setShipToManuallySet] = useState(false);
    const [bill_To_Name, setBillToName] = useState('')
    const [ship_To_Name, setShipToName] = useState('')


    const selectedRecord = location.state?.selectedRecord;
    const navigate = useNavigate();
    const inputRef = useRef(null)

    //SET Focus to the ADD Buttons.
    const addButtonRef = useRef(null);
    const firstInputRef = useRef(null);
    const setFocusToFirstField = () => {
        if (firstInputRef.current) {
            firstInputRef.current.focus();
        }
    };

    //Initial Formdata
    const initialFormData = {
        doc_no: "",
        doc_date: new Date().toISOString().split("T")[0],
        Ac_Code: "",
        Company_Code: companyCode,
        Year_Code: Year_Code,
        Created_By: "",
        Modified_By: "",
        ac: 0,
        SubTotal: 0.00,

    };

    //ALL Help Section State managements
    const [formData, setFormData] = useState(initialFormData);
    const [billFrom, setBillFrom] = useState("");
    const [partyMobNo, setPartyMobNo] = useState("");
    const [billTo, setBillTo] = useState("");

    const [millGSTNo, setMillGSTNo] = useState("");
    const [shipTo, setShipTo] = useState("");
    const [shipToMobNo, setShipToMobNo] = useState("");
    const [gstCode, setGstCode] = useState("");
    const [transport, setTransport] = useState("");
    const [transportMob, setTransportMob] = useState("");
    const [broker, setBroker] = useState("");
    const [GstRate, setGstRate] = useState(0.0);
    const [matchStatus, setMatchStatus] = useState(null);
    const [godown_Code, setGoDownCode] = useState('')
    const [godownId, setGodownId] = useState('')
    const [godownName, setGodownName] = useState('')


    // Manage the lock-unlock record at the same time multiple users edit the same record.
    const { isRecordLockedByUser, lockRecord, unlockRecord } = useRecordLocking(formData.doc_no, undefined, companyCode, Year_Code, "sugar_sale");

    //Validation Input feilds
    const validateNumericInput = (e) => {
        e.target.value = e.target.value.replace(/[^0-9.-]/g, '');
    };

    //Handle Records OnChange Method
    const handleChange = (event) => {
        const { name, value } = event.target;
        const updatedValue = name === "LORRYNO" ? formatTruckNumber(value) : value;
        setFormData((prevData) => ({
            ...prevData,
            [name]: updatedValue,
        }));
    };

    //Calculations on GST Rate Code
    const handleKeyDownCalculations = async (event) => {
        if (event.key === "Tab") {
            const { name, value } = event.target;
            const matchStatus = await checkMatchStatus(
                formData.Ac_Code,
                companyCode,
                Year_Code
            );
            let gstRate = GstRate;

            if (!gstRate || gstRate === 0) {
                const cgstRate = parseFloat(formData.CGSTRate) || 0;
                const sgstRate = parseFloat(formData.SGSTRate) || 0;
                const igstRate = parseFloat(formData.IGSTRate) || 0;
                gstRate = igstRate > 0 ? igstRate : cgstRate + sgstRate;
            }
            // const updatedFormData = await calculateDependentValues(
            //     name,
            //     value,
            //     formData,
            //     matchStatus,
            //     gstRate
            // );
            // setFormData(updatedFormData);
        }
    };

    const handleOnChange = () => {
        setIsChecked((prev) => {
            const newValue = !prev;
            const value = newValue ? "Y" : "N";

            setFormData((prevData) => ({
                ...prevData,
                EWayBill_Chk: value,
            }));
            return newValue;
        });
    };

    //handle the Date OnChange Values
    const handleDateChange = (event, fieldName) => {
        setFormData((prevFormData) => ({
            ...prevFormData,
            [fieldName]: event.target.value,
        }));
    };

    useEffect(() => {
        if (isHandleChange) {
            handleCancel();
            setIsHandleChange(false);
        }
    }, []);

    //fetchLast Records to get the next doc no
    const fetchLastRecord = () => {
        fetch(
            `${API_URL}/get-gulsalereturn-next-doc-no?Company_Code=${companyCode}&Year_Code=${Year_Code}`
        )
            .then((response) => {
                if (!response.ok) {
                    throw new Error("Failed to fetch last record");
                }
                return response.json();
            })
            .then((data) => {
                const newDocNo = data.next_doc_no;
                setFormData((prevState) => ({
                    ...prevState,
                    doc_no: newDocNo,
                }));
            })
            .catch((error) => {
                console.error("Error fetching last record:", error);
            });
    };

    //handle record Add.
    const handleAddOne = async () => {
        setAddOneButtonEnabled(false);
        setSaveButtonEnabled(true);
        setCancelButtonEnabled(true);
        setEditButtonEnabled(false);
        setDeleteButtonEnabled(false);
        setIsEditMode(false);
        setIsEditing(true);
        fetchLastRecord();
        setFormData(initialFormData);
        partyName = "";
        partyCode = "";
        unitName = "";
        unitCode = "";
        brokerName = "";
        brokerCode = "";
        itemName = "";
        item_Code = "";
        gstrate = "";
        gstRateCode = "";
        brandName = "";
        brandCode = "";
        transportName = "";
        transportCode = "";
        billToName = "";
        billToCode = "";
        gstName = "";
        newGodownCode = '';
        lblGodownName = '';
        setLastTenderDetails([]);
        setTimeout(() => {
            inputRef.current?.focus();
        }, 0);
    };

    //handle Edit record functionality.
    const handleEdit = async () => {
        // const Post_Date = sessionStorage.getItem("Post_Date");
        // const Outword_Date = sessionStorage.getItem("Outword_Date")
        // if (await OutwordPostDateRecordLock(formData.doc_date, Post_Date, Outword_Date)) {
        //     return;
        // }

        if (
            (formData.einvoiceno && formData.einvoiceno.trim() !== "" && formData.ackno && formData.ackno.trim() !== "") ||
            (formData.EWay_Bill_No && formData.EWay_Bill_No.trim() !== "")
        ) {
            let message = "";

            if (formData.einvoiceno && formData.einvoiceno.trim() !== "" && formData.ackno && formData.ackno.trim() !== "") {
                message += "E-Invoice has already been generated for this record.";
            }

            if (formData.EWay_Bill_No && formData.EWay_Bill_No.trim() !== "") {
                message += (message ? "\n" : "") + "E-WayBill has already been generated for this record.";
            }

            Swal.fire({
                icon: "warning",
                text: message,
                confirmButtonColor: "#d33",
            });

        }

        axios.get(`${API_URL}/gulSaleBillreturnByid?srid=${formData.srid}&Company_Code=${companyCode}&Year_Code=${Year_Code}`)
            .then((response) => {
                const data = response.data;
                const isLockedNew = data.last_head_data.LockedRecord;
                const isLockedByUserNew = data.last_head_data.LockedUser;

                if (isLockedNew) {
                    Swal.fire({
                        icon: "warning",
                        title: "Record Locked",
                        text: `This record is locked by ${isLockedByUserNew}`,
                        confirmButtonColor: "#d33",
                    });
                    return
                }
                else {
                    lockRecord();
                }
                setFormData({
                    ...formData,
                    ...data.last_head_data
                });
                setIsEditMode(true);
                setAddOneButtonEnabled(false);
                setSaveButtonEnabled(true);
                setCancelButtonEnabled(true);
                setEditButtonEnabled(false);
                setDeleteButtonEnabled(false);
                setBackButtonEnabled(true);
                setIsEditing(true);
            })
            .catch((error) => {
                window.alert("This record is already deleted! Showing the previous record.");
            });
    };

    // Record save and update functionality
    const handleSaveOrUpdate = async () => {

        // const Post_Date = sessionStorage.getItem("Post_Date");
        // const Outword_Date = sessionStorage.getItem("Outword_Date")
        // if (await OutwordPostDateRecordLock(formData.doc_date, Post_Date, Outword_Date)) {
        //     return;
        // }

        const accountingYearData = sessionStorage.getItem('Accounting_Year');
        const formattedEntryDate = formData.doc_date;
        const isValid = validateDocumentDate(formattedEntryDate, accountingYearData);

        if (!isValid) {
            return
        }

        let missingFields = [];
        // if (!formData.GstRateCode) missingFields.push("GST Code");
        if (!formData.Ac_Code) missingFields.push("Bill From");
        // if (!formData.Bill_To) missingFields.push("Bill To");
        // if (!formData.Unit_Code) missingFields.push("Ship To");
        // if (!formData.mill_code) missingFields.push("Mill Name");

        if (missingFields.length > 0) {
            Swal.fire({
                text: `Please Select the following fields: ${missingFields.join(", ")}`,
                icon: "warning",
                confirmButtonText: "OK"
            });
            return;
        }

        if (users.length === 0 || users.every(user => user.rowaction === "DNU" || user.rowaction === "delete")) {
            Swal.fire({
                text: "Please add at least one entry in the detail grid.",
                icon: "warning",
                confirmButtonText: "OK"
            });
            return;
        }

        setIsEditing(true);
        setIsLoading(true);

        let headData = {
            ...formData,
            // GstRateCode: gstCode || gstRateCode,
            // RateDiff: formData.RateDiff || 0,
            ...(isEditMode
                ? {
                    Modified_By: username,
                    // User_Id: User_Id
                }
                : {
                    Created_By: username
                }
            )
        };
        delete headData[""];
        // delete headData.RateDiffAmount
        if (isEditMode) {
            delete headData.srid;
            headData.Modified_By = username
            // headData.User_Id = User_Id
        } else {
            headData.Created_By = username;
        }
        const detailData = users.map((user) => ({
            rowaction: user.rowaction,
            srdtid: user.srdtid,
            item_code: user.item_code,
            Quantity: user.Quantity,
            ic: user.ic,
            detail_id: 1,
            Netkg: user.Netkg,
            item_Amount: user.item_Amount,
            narration: user.narration,
            Packing: user.Packing,
            DrCr: user.DrCr,
            Company_Code: companyCode,
            Year_Code: Year_Code,
        }));

        const requestData = {
            headData,
            detailData,
        };

        try {
            if (isEditMode) {
                const updateApiUrl = `${API_URL}/update-gullSaleBillreturn?srid=${newSaleid}`;
                const response = await axios.put(updateApiUrl, requestData);

                unlockRecord();
                Swal.fire({
                    title: "Success!",
                    text: "Record updated successfully!",
                    icon: "success",
                    confirmButtonText: "OK"
                });

                setTimeout(() => {
                    window.onbeforeunload = null;
                    window.location.reload();
                }, 1000);
                navigate(`/Gullsalereturn?navigatedRecord=${formData.doc_no}`);
            } else {
                const response = await axios.post(
                    `${API_URL}/insert-gullSaleBillreturn`,
                    requestData
                );
                Swal.fire({
                    title: "Success!",
                    text: "Record saved successfully!",
                    icon: "success",
                    confirmButtonText: "OK"
                });
                setIsEditMode(false);
                setAddOneButtonEnabled(true);
                setEditButtonEnabled(true);
                setDeleteButtonEnabled(true);
                setBackButtonEnabled(true);
                setSaveButtonEnabled(false);
                setCancelButtonEnabled(false);
                setIsEditing(true);

                setTimeout(() => {
                    window.location.reload();
                }, 1000);
                navigate(`/Gullsalereturn?navigatedRecord=${formData.doc_no}`);
            }
        } catch (error) {
            console.error("Error during API call:", error);
            toast.error("Error occurred while saving data");
        } finally {
            setIsEditing(false);
            setIsLoading(false);
        }
    };


    const handleDelete = async () => {
        const Post_Date = sessionStorage.getItem("Post_Date");
        const Outword_Date = sessionStorage.getItem("Outword_Date")
        if (await OutwordPostDateRecordLock(formData.doc_date, Post_Date, Outword_Date)) {
            return;
        }

        // if (parseInt(formData.DO_No) !== 0) {
        //     Swal.fire({
        //         title: "Error",
        //         text: `Couldn't delete this record it is currently referenced in DO No. ${formData.DO_No}`.trim(),
        //         icon: "error",
        //         confirmButtonText: "OK"
        //     });
        //     return;
        // }

        // if (parseInt(formData.einvoiceno) !== "" && formData.ackno !== "") {
        //     Swal.fire({
        //         icon: "warning",
        //         text: "E-Invoice has already been generated for this record.Cannot Delete.",
        //         confirmButtonColor: "#d33",
        //     });
        //     return
        // }

        // if (formData.EWay_Bill_No !== "") {
        //     Swal.fire({
        //         icon: "warning",
        //         text: "E-WayBill has already been generated for this record.Cannot Delete.",
        //         confirmButtonColor: "#d33",
        //     });
        //     return
        // }

        try {
            const response = await axios.get(
                `${API_URL}/gulSaleBillreturnByid?srid=${newSaleid}&Company_Code=${companyCode}&Year_Code=${Year_Code}`
            );

            const data = response.data;
            const isLockedNew = data.last_head_data.LockedRecord;
            const isLockedByUserNew = data.last_head_data.LockedUser;

            if (isLockedNew) {
                Swal.fire({
                    title: "Record Locked",
                    text: `This record is locked by ${isLockedByUserNew}`,
                    icon: "warning",
                    confirmButtonText: "OK",
                });
                return;
            }

            const result = await Swal.fire({
                title: "Are you sure?",
                text: `Do you really want to delete this Doc No: ${formData.doc_no}?`,
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#d33",
                cancelButtonColor: "#3085d6",
                cancelButtonText: "Cancel",
                confirmButtonText: "Delete",
                reverseButtons: true,
                focusCancel: true,
            });

            if (result.isConfirmed) {
                setIsEditMode(false);
                setAddOneButtonEnabled(true);
                setEditButtonEnabled(true);
                setDeleteButtonEnabled(true);
                setBackButtonEnabled(true);
                setSaveButtonEnabled(false);
                setCancelButtonEnabled(false);
                setIsLoading(true);

                const deleteApiUrl = `${API_URL}/delete_data_by_gullsaleidreturn?srid=${newSaleid}&Company_Code=${companyCode}&doc_no=${formData.doc_no}&Year_Code=${Year_Code}&User_Id=${User_Id}`;
                const deleteResponse = await axios.delete(deleteApiUrl);

                if (deleteResponse.status === 200) {
                    if (deleteResponse.data) {
                        Swal.fire({
                            title: "Deleted!",
                            text: "Data deleted successfully!",
                            icon: "success",
                            confirmButtonText: "OK",
                        });
                        handleCancel();
                    }
                } else {
                    Swal.fire({
                        title: "Error",
                        text: "Failed to delete the record.",
                        icon: "error",
                        confirmButtonText: "OK",
                    });
                }
            } else {
                Swal.fire({
                    title: "Cancelled",
                    text: "Your record is safe 🙂",
                    icon: "info",
                    confirmButtonText: "OK",
                });
            }
        } catch (error) {
            console.error("Error during API call:", error);
            Swal.fire({
                title: "Error",
                text: `There was an error during the deletion: ${error.message}`,
                icon: "error",
                confirmButtonText: "OK",
            });
        } finally {
            setIsLoading(false);
        }
    };


    //Common Feilds that we haev to set the record on the navigations.
    const NavigationSetFields = (headData, detailData) => {
        const details = detailData[0];
        newSaleid = headData.srid;
        partyName = details.partyname;
        partyCode = headData.Ac_Code;
        itemName = details.itemname;
        item_Code = details.item_code;


        setFormData((prevData) => ({
            ...prevData,
            ...headData,
        }));

        setLastTenderData(headData || {});
        setLastTenderDetails(detailData || []);
    };

    // handle cancel get last record data and set to
    const handleCancel = async () => {
        setIsEditing(false);
        setIsEditMode(false);
        setAddOneButtonEnabled(true);
        setEditButtonEnabled(true);
        setDeleteButtonEnabled(true);
        setBackButtonEnabled(true);
        setSaveButtonEnabled(false);
        setCancelButtonEnabled(false);
        setCancelButtonClicked(true);

        try {
            const response = await axios.get(
                `${API_URL}/get-lastgullSaleBillreturn-navigation?Company_Code=${companyCode}&Year_Code=${Year_Code}`
            );
            if (response.status === 200) {
                const data = response.data;
                NavigationSetFields(data.last_head_data, data.last_details_data);
                setIsChecked(true);
                unlockRecord();
            } else {
                console.error(
                    "Failed to fetch last data:",
                    response.status,
                    response.statusText
                );
            }
        } catch (error) {
            console.error("Error during API call:", error);
        }
    };

    // handle back button to navigate to the dashboard page.
    const handleBack = () => {
        navigate("/Gullsalereturnutility");
    };

    // Navigation Funtionality 
    const handleFirstButtonClick = async () => {
        try {
            const response = await axios.get(
                `${API_URL}/get-firstgullSaleBillreturn-navigation?Company_Code=${companyCode}&Year_Code=${Year_Code}`
            );
            if (response.status === 200) {
                const data = response.data;
                NavigationSetFields(data.first_head_data, data.first_details_data);
            } else {
                console.error(
                    "Failed to fetch first tender data:",
                    response.status,
                    response.statusText
                );
            }
        } catch (error) {
            console.error("Error during API call:", error);
        }
    };

    const handleLastButtonClick = async () => {
        try {
            const response = await axios.get(
                `${API_URL}/get-lastgullSaleBillreturn-navigation?Company_Code=${companyCode}&Year_Code=${Year_Code}`
            );
            if (response.status === 200) {
                const data = response.data;
                NavigationSetFields(data.last_head_data, data.last_details_data);
            } else {
                console.error(
                    "Failed to fetch last tender data:",
                    response.status,
                    response.statusText
                );
            }
        } catch (error) {
            console.error("Error during API call:", error);
        }
    };

    const handleNextButtonClick = async () => {
        try {
            const response = await axios.get(
                `${API_URL}/get-nextgullSaleBillreturn-navigation?Company_Code=${companyCode}&Year_Code=${Year_Code}&currentDocNo=${formData.doc_no}`
            );
            if (response.status === 200) {
                const data = response.data;
                NavigationSetFields(data.next_head_data, data.next_details_data);
            } else {
                console.error(
                    "Failed to fetch next tender data:",
                    response.status,
                    response.statusText
                );
            }
        } catch (error) {
            console.error("Error during API call:", error);
        }
    };

    const handlePreviousButtonClick = async () => {
        try {
            const response = await axios.get(
                `${API_URL}/get-previousgullSaleBillreturn-navigation?Company_Code=${companyCode}&Year_Code=${Year_Code}&currentDocNo=${formData.doc_no}`
            );

            if (response.status === 200) {
                const data = response.data;
                NavigationSetFields(data.previous_head_data, data.previous_details_data);
            } else {
                console.error(
                    "Failed to fetch previous tender data:",
                    response.status,
                    response.statusText
                );
            }
        } catch (error) {
            console.error("Error during API call:", error);
        }
    };

    const handleSubmit = (event) => {
        event.preventDefault();
    };

    useEffect(() => {
        if (selectedRecord) {
            handlerecordDoubleClicked();
        }
        else if (navigatedRecord && !isNaN(navigatedRecord) && parseInt(navigatedRecord) > 0) {
            handleNavigateRecord();
        }
        else {
            handleAddOne();
        }
    }, [selectedRecord, navigatedRecord]);

    const handlerecordDoubleClicked = async () => {
        setIsEditing(false);
        setIsEditMode(false);
        setAddOneButtonEnabled(true);
        setEditButtonEnabled(true);
        setDeleteButtonEnabled(true);
        setBackButtonEnabled(true);
        setSaveButtonEnabled(false);
        setCancelButtonEnabled(false);
        setCancelButtonClicked(true);
        try {
            const response = await axios.get(
                `${API_URL}/gulSaleBillreturnByid?srid=${selectedRecord.srid}&Company_Code=${companyCode}&Year_Code=${Year_Code}`
            );
            if (response.status === 200) {
                const data = response.data;

                newSaleid = data.last_head_data.srid;
                partyName = data.last_details_data[0].partyname;
                partyCode = data.last_head_data.Ac_Code;
                itemName = data.last_details_data[0].itemname;
                item_Code = data.last_details_data[0].item_code;

                setFormData((prevData) => ({
                    ...prevData,
                    ...data.last_head_data,
                }));
                setLastTenderData(data.last_head_data || {});
                setLastTenderDetails(data.last_details_data || []);
            } else {
                console.error(
                    "Failed to fetch last tender data:",
                    response.status,
                    response.statusText
                );
            }
        } catch (error) {
            console.error("Error during API call:", error);
        }
    };

    const handleNavigateRecord = async () => {
        setIsEditing(false);
        setIsEditMode(false);
        setAddOneButtonEnabled(true);
        setEditButtonEnabled(true);
        setDeleteButtonEnabled(true);
        setBackButtonEnabled(true);
        setSaveButtonEnabled(false);
        setCancelButtonEnabled(false);
        setCancelButtonClicked(true);
        try {
            const response = await axios.get(
                `${API_URL}/gulSaleBillreturnByDocNo?doc_no=${navigatedRecord}&Company_Code=${companyCode}&Year_Code=${Year_Code}`
            );
            if (response.status === 200) {
                const data = response.data;

                newSaleid = data.last_head_data.srid;
                partyName = data.last_details_data[0].partyname;
                partyCode = data.last_head_data.Ac_Code;


                itemName = data.last_details_data[0].itemname;
                item_Code = data.last_details_data[0].item_code;

                setFormData((prevData) => ({
                    ...prevData,
                    ...data.last_head_data,
                }));
                setLastTenderData(data.last_head_data || {});
                setLastTenderDetails(data.last_details_data || []);
            } else {
                console.error(
                    "Failed to fetch last tender data:",
                    response.status,
                    response.statusText
                );
            }
        } catch (error) {
            console.error("Error during API call:", error);
        }
    };

    const handleKeyDown = async (event) => {
        if (event.key === "Tab") {
            const changeNoValue = event.target.value;
            try {
                const response = await axios.get(
                    `${API_URL}/gulSaleBillreturnByDocNo?doc_no=${changeNoValue}&Company_Code=${companyCode}&Year_Code=${Year_Code}`
                );
                const data = response.data;
                newSaleid = data.last_head_data.srid;
                partyName = data.last_details_data[0].partyname;
                partyCode = data.last_head_data.Ac_Code;

                itemName = data.last_details_data[0].itemname;
                item_Code = data.last_details_data[0].item_code;


                setFormData({
                    ...formData,
                    ...data.last_head_data,
                });
                setLastTenderData(data.last_head_data || {});
                setLastTenderDetails(data.last_details_data || []);
                setIsEditing(false);
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        }
    };

    const checkMatchStatus = async (ac_code, company_code, year_code) => {
        try {
            const { data } = await axios.get(
                `${process.env.REACT_APP_API}/get_match_status`,
                {
                    params: {
                        Ac_Code: ac_code,
                        Company_Code: company_code,
                        Year_Code: year_code,
                    },
                }
            );
            return data.match_status;
        } catch (error) {
            console.error("Couldn't able to match GST State Code:", error);
            return error;
        }
    };

    useEffect(() => {
        if (!isChecked) {
            fetchCompanyGSTCode(companyCode);
        }
    }, [isChecked, companyCode]);

    const fetchCompanyGSTCode = async (company_code) => {
        try {
            const { data } = await axios.get(
                `${API_URL}/get_company_by_code?company_code=${company_code}`
            );
            setGstNo(data.GST);
        } catch (error) {
            console.error("Error:", error);
            setGstNo("");
        }
    };

    const calculateTotalItemAmount = (users) => {
        return users
            .filter((user) => user.rowaction !== "delete" && user.rowaction !== "DNU")
            .reduce((sum, user) => sum + parseFloat(user.item_Amount || 0), 0);
    };



    //-------------------------------------------- Detail Section Start ----------------------------------------------------
    useEffect(() => {

        if (selectedRecord) {
            setUsers(
                lastTenderDetails.map((detail) => ({
                    item_code: detail.item_code,
                    item_Name: detail.item_Name,
                    rowaction: "Normal",
                    ic: detail.ic,
                    id: detail.srdtid,
                    srdtid: detail.srdtid,
                    narration: detail.narration,
                    Quantity: detail.Quantity,
                    DrCr: detail.DrCr,
                    Packing: detail.Packing,
                    Netkg: detail.Netkg,
                    item_Amount: detail.item_Amount,
                }))
            );
        }
    }, [selectedRecord, lastTenderDetails]);

    useEffect(() => {

        const updatedUsers = lastTenderDetails.map((detail) => ({
            item_code: detail.item_code,
            item_Name: detail.item_Name,
            rowaction: "Normal",
            ic: detail.ic,
            id: detail.srdtid,
            srdtid: detail.srdtid,
            narration: detail.narration,
            Quantity: detail.Quantity,
            DrCr: detail.DrCr,
            Packing: detail.Packing,
            Netkg: detail.Netkg,
            item_Amount: detail.item_Amount,
        }));
        setUsers(updatedUsers);
    }, [lastTenderDetails]);


    const calculateTotals = (users) => {
        return users.reduce(
            (totals, user) => {
                if (user.rowaction !== "delete" && user.rowaction !== "DNU") {
                    totals.totalQty += parseFloat(user.Quantity || 0.00);
                    totals.totalNetwt += parseFloat(user.Netkg || 0);
                    totals.totalamt += parseFloat(user.item_Amount || 0.00);

                }
                return totals;
            },
            { totalQty: 0, totalNetwt: 0, totalamt: 0, }
        );
    };

    const { totalNetwt, totalQty, totalamt } = calculateTotals(users);




    const handleChangeDetail = (event) => {
        const { name, value } = event.target;

        setFormDataDetail((prevDetail) => {
            const updatedDetail = {
                ...prevDetail,
                [name]:
                    name === "Netkg" ||
                        name === "Quantity" ||
                        name === "Packing"
                        ? parseFloat(value) || 0
                        : value,
            };


            return {
                ...updatedDetail,
                // item_Amount: result.item_Amount,
                // Market_Cess: result.MarketCess,
                // Dekrekh: result.DekhRekh,
                // Hamali: result.Hamali,
                // Tolai: result.Tolai,
                // leavy: result.Leavy,
            };
        });
    };

    const addUser = async () => {
        if (itemCode === "") {
            Swal.fire({
                icon: "warning",
                text: "Please Select Item.",
                confirmButtonColor: "#d33",
            });
            return false;
        }
        const newUser = {
            id: users.length > 0 ? Math.max(...users.map((user) => user.id)) + 1 : 1,
            item_code: itemCode,
            item_Name: item_Name,
            ic: itemCodeAccoid,
            Brand_Code: brand_code,
            brand_name: brand_name,
            ...formDataDetail,
            rowaction: "add",
        };

        const updatedUsers = [...users, newUser];
        setUsers(updatedUsers);


        const total = calculateTotals(updatedUsers);
        const netquat = total.totalQty;
        const netWt = parseFloat(Number(total.totalNetwt).toFixed(2));
        const subtotal = parseFloat(Number(total.totalamt).toFixed(2));

        let updatedFormData = {
            ...formData,
            NETQNTL: netquat,
            NETWT: netWt,
            SubTotal: subtotal,

        };

        const matchStatus = await checkMatchStatus(
            updatedFormData.Ac_Code,
            companyCode,
            Year_Code
        );
        let gstRate = GstRate;
        if (!gstRate || gstRate === 0) {
            const cgstRate = parseFloat(formData.CGSTRate) || 0;
            const sgstRate = parseFloat(formData.SGSTRate) || 0;
            const igstRate = parseFloat(formData.IGSTRate) || 0;

            gstRate = igstRate > 0 ? igstRate : cgstRate + sgstRate;
        }



        setFormData(updatedFormData);
        closePopup();
    };

    const updateUser = async () => {

        const updatedUsers = users.map((user) => {
            if (user.id === selectedUser.id) {
                const updatedRowaction =
                    user.rowaction === "Normal" ? "update" : user.rowaction;
                return {
                    ...user,
                    Brand_Code: brand_code,
                    brand_name: brand_name,
                    item_code: itemCode,
                    item_Name: item_Name,
                    ic: itemCodeAccoid,
                    Packing: formDataDetail.Packing,
                    Netkg: formDataDetail.Netkg,
                    item_Amount: formDataDetail.item_Amount,
                    Quantity: formDataDetail.Quantity,
                    DrCr: formDataDetail.DrCr,
                    narration: formDataDetail.narration,
                    rowaction: updatedRowaction,
                };
            } else {
                return user;
            }
        });

        setUsers(updatedUsers);



        const total = calculateTotals(updatedUsers);

        const netquat = total.totalQty;
        const netWt = parseFloat(Number(total.totalNetwt).toFixed(2));
        const subtotal = parseFloat(Number(total.totalamt).toFixed(2));

        let updatedFormData = {
            ...formData,
            NETQNTL: netquat,
            NETWT: netWt,
            SubTotal: subtotal,

        };
        const matchStatus = await checkMatchStatus(
            updatedFormData.Ac_Code,
            companyCode,
            Year_Code
        );

        let gstRate = GstRate;
        if (!gstRate || gstRate === 0) {
            const cgstRate = parseFloat(formData.CGSTRate) || 0;
            const sgstRate = parseFloat(formData.SGSTRate) || 0;
            const igstRate = parseFloat(formData.IGSTRate) || 0;

            gstRate = igstRate > 0 ? igstRate : cgstRate + sgstRate;
        }



        setFormData(updatedFormData);
        closePopup();
    };

    const deleteModeHandler = async (user) => {
        let updatedUsers;
        if (isEditMode && user.rowaction === "add") {
            setDeleteMode(true);
            setSelectedUser(user);
            updatedUsers = users.map((u) =>
                u.id === user.id ? { ...u, rowaction: "DNU" } : u
            );
        } else if (isEditMode) {
            setDeleteMode(true);
            setSelectedUser(user);
            updatedUsers = users.map((u) =>
                u.id === user.id ? { ...u, rowaction: "delete" } : u
            );
        } else {
            setDeleteMode(true);
            setSelectedUser(user);
            updatedUsers = users.map((u) =>
                u.id === user.id ? { ...u, rowaction: "DNU" } : u
            );
        }
        setUsers(updatedUsers);
        setSelectedUser({});



        const total = calculateTotals(updatedUsers);
        const netquat = total.totalQty;
        const netWt = parseFloat(Number(total.totalNetwt).toFixed(2));
        const subtotal = parseFloat(Number(total.totalamt).toFixed(2));

        let updatedFormData = {
            ...formData,
            NETQNTL: netquat,
            NETWT: netWt,
            SubTotal: subtotal,

        };

        const matchStatus = await checkMatchStatus(
            updatedFormData.Ac_Code,
            companyCode,
            Year_Code
        );

        let gstRate = GstRate;
        if (!gstRate || gstRate === 0) {
            const cgstRate = parseFloat(formData.CGSTRate) || 0;
            const sgstRate = parseFloat(formData.SGSTRate) || 0;
            const igstRate = parseFloat(formData.IGSTRate) || 0;

            gstRate = igstRate > 0 ? igstRate : cgstRate + sgstRate;
        }


        setFormData(updatedFormData);
    };

    const openDelete = async (user) => {
        setDeleteMode(true);
        setSelectedUser(user);
        let updatedUsers;
        if (isEditMode && user.rowaction === "delete") {
            updatedUsers = users.map((u) =>
                u.id === user.id ? { ...u, rowaction: "Normal" } : u
            );
        } else {
            updatedUsers = users.map((u) =>
                u.id === user.id ? { ...u, rowaction: "add" } : u
            );
        }
        setUsers(updatedUsers);
        setSelectedUser({});


        const total = calculateTotals(updatedUsers);
        const netquat = total.totalQty;
        const netWt = parseFloat(Number(total.totalNetwt).toFixed(2));
        const subtotal = parseFloat(Number(total.totalamt).toFixed(2));
        let updatedFormData = {
            ...formData,
            NETQNTL: netquat,
            NETWT: netWt,
            SubTotal: subtotal,

        };

        const matchStatus = await checkMatchStatus(
            updatedFormData.Ac_Code,
            companyCode,
            Year_Code
        );

        let gstRate = GstRate;
        if (!gstRate || gstRate === 0) {
            const cgstRate = parseFloat(formData.CGSTRate) || 0;
            const sgstRate = parseFloat(formData.SGSTRate) || 0;
            const igstRate = parseFloat(formData.IGSTRate) || 0;

            gstRate = igstRate > 0 ? igstRate : cgstRate + sgstRate;
        }



        setFormData(updatedFormData);
    };

    const openPopup = (mode) => {
        setPopupMode(mode);
        setShowPopup(true);
        if (mode === "add") {
            clearForm();
        }
    };

    const closePopup = () => {
        setShowPopup(false);
        setSelectedUser({});
        clearForm();
    };

    const clearForm = () => {
        setFormDataDetail({
            narration: "",
            Packing: 50 || 0,
            Quantity: 0.0,
            DrCr: "",
            bags: 0,
        });
        setItemCode("");
        setItemName("");
        setBrandCode("");
        setBrandName("");
    };

    const editUser = (user) => {

        setSelectedUser(user);
        setItemCode(user.item_code);
        setItemName(user.item_Name);
        setBrandCode(user.Brand_Code);
        setBrandName(user.brand_name);
        setItemCodeAccoid(user.ic);
        setFormDataDetail({
            narration: user.narration || "",
            Packing: user.Packing || 0,
            Quantity: user.Quantity || 0.0,
            DrCr: user.DrCr || "",
            Netkg: user.Netkg || 0,
            item_Amount: user.item_Amount || 0,
        });
        openPopup("edit");
    };

    const handleItemCode = async (code, accoid, hsn, name) => {
        setItemCode(code);
        setItemName(name);
        setItemCodeAccoid(accoid);
        try {

            const Company_Code = sessionStorage.getItem("Company_Code");
            const Year_Code = sessionStorage.getItem("Year_Code");

            const response = await fetch(
                `${API_URL}/getdata-ItemByidForrates?Company_Code=${Company_Code}&ic=${accoid}`
            );

            const data = await response.json();

            if (data.all_data && data.all_data.length > 0) {
                const itemRates = data.all_data[0];

                setFormDataDetail((prev) => ({
                    ...prev,
                    // Rates
                    Market_Rate: itemRates.Market_Cess || 0,
                    Dekrekh_Rate: itemRates.Dekrekh || 0,
                    Leavy_Rate: itemRates.Levi_rate || 0,
                    Tolai_Rate: itemRates.Tolai_rate || 0,
                    Hamali_Rate: itemRates.Hamali_rate || 0,
                }));
            }
        } catch (error) {
            console.error("Error fetching item rates:", error);
        }
    };

    const handleBrandCode = (code, name) => {
        setBrandCode(code);
        setBrandName(name);
    };


    //Head Section help Functions to manage the Ac_Code and accoid
    const handleBillFrom = async (code, accoid, Name, Mobile_No, Gst_No, TDSApplicable, GSTStateCode, cityname, State_Name, Commission, Ac_rate) => {
        setBillFrom(code);
        setPartyMobNo(Mobile_No);
        let updatedFormData = {
            ...formData,
            Ac_Code: code,
            ac: accoid,
            // TO_STATION: cityname,
            // Commission_Rate: Commission,
        };
        try {


            setFormData(updatedFormData);

        } catch (error) {
            console.error("Error in handleBillFrom:", error);
        }
    };


    return (
        <>
            <UserAuditInfo
                createdBy={formData.Created_By}
                modifiedBy={formData.Modified_By}
                title={"Gul Sale Return"}
            />
            <ToastContainer autoClose={500} />
            <br></br>
            <ActionButtonGroup
                handleAddOne={handleAddOne}
                addOneButtonEnabled={addOneButtonEnabled}
                handleSaveOrUpdate={handleSaveOrUpdate}
                saveButtonEnabled={saveButtonEnabled}
                isEditMode={isEditMode}
                handleEdit={handleEdit}
                editButtonEnabled={editButtonEnabled}
                handleDelete={handleDelete}
                deleteButtonEnabled={deleteButtonEnabled}
                handleCancel={handleCancel}
                cancelButtonEnabled={cancelButtonEnabled}
                handleBack={handleBack}
                backButtonEnabled={backButtonEnabled}
                isDeleted={formData.IsDeleted === 0}
                permissions={permissions}
                component={<div style={{ display: 'flex' }} >





                </div>}
            />
            <NavigationButtons
                handleFirstButtonClick={handleFirstButtonClick}
                handlePreviousButtonClick={handlePreviousButtonClick}
                handleNextButtonClick={handleNextButtonClick}
                handleLastButtonClick={handleLastButtonClick}
                highlightedButton={highlightedButton}
                isEditing={isEditing}
            />

            <form onSubmit={handleSubmit}>
                <Grid container alignItems="center" spacing={1} mt={0.5}>
                    <Grid item xs={12} sm={1}>
                        <FormControl fullWidth>
                            <TextField
                                label="Change No"
                                variant="outlined"
                                name="changeNo"
                                autoComplete="off"
                                onKeyDown={handleKeyDown}
                                disabled={!addOneButtonEnabled}
                                fullWidth
                                size="small"
                            />
                        </FormControl>
                    </Grid>

                    <Grid item xs={6} sm={1}>
                        <FormControl >
                            <TextField
                                label="Bill No"
                                variant="outlined"
                                name="doc_no"
                                autoComplete="off"
                                value={formData.doc_no}
                                onChange={handleChange}
                                disabled
                                fullWidth
                                size="small"
                            />
                        </FormControl>
                    </Grid>

                    <Grid item xs={6} sm={1}>
                        <FormControl >
                            <TextField
                                inputRef={inputRef}
                                type="date"
                                label="Date"
                                variant="outlined"
                                name="doc_date"
                                value={formData.doc_date}
                                onChange={handleChange}
                                disabled={!isEditing && addOneButtonEnabled}
                                fullWidth
                                size="small"
                                InputLabelProps={{
                                    style: { fontSize: '14px' },
                                }}
                                InputProps={{
                                    style: { fontSize: '12px', height: '40px' },
                                }}
                            />
                        </FormControl>
                    </Grid>

                    <Grid item xs={12} sm={1} ml={7}>
                        <FormControl >
                            <TextField
                                label="DO No"
                                variant="outlined"
                                name="DO_No"
                                autoComplete="off"
                                value={formData.DO_No}
                                // onChange={handleChange}
                                disabled
                                fullWidth
                                size="small"
                            />
                        </FormControl>
                    </Grid>

                </Grid>

                <div className="SugarSaleBill-row" style={{ marginTop: "10px", marginBottom: "15px" }}>
                    <label htmlFor="Bill_From" className="SugarSaleBillLabel" >
                        Bill From :
                    </label>
                    <div >
                        <div >
                            <AccountMasterHelp
                                onAcCodeClick={handleBillFrom}
                                CategoryName={partyName}
                                CategoryCode={partyCode}
                                name="Ac_Code"
                                Ac_type={[]}
                                disabledFeild={!isEditing && addOneButtonEnabled}
                            />
                        </div>
                    </div>
                </div>



                {isLoading && (
                    <div className="loading-overlay">
                        <div className="spinner-container">
                            <SaveUpdateSpinner />
                        </div>
                    </div>
                )}

                <div style={{ marginTop: "10px" }}>
                    <AddButton openPopup={openPopup} isEditing={isEditing} ref={addButtonRef} setFocusToFirstField={setFocusToFirstField} />
                </div>

                {/*detail part popup functionality and Validation part Grid view */}
                <div className="">
                    {showPopup && (
                        <div className="sugar-salebill-modal" role="dialog" style={{ display: "block" }}>
                            <div className="sugar-salebill-modal-dialog" role="document">
                                <div className="modal-content">
                                    <div className="sugar-salebill-modal-header">
                                        <h5 className="sugar-salebill-modal-title">
                                            {selectedUser.id ? "Update Sale Bill" : "Add Sale Bill"}
                                        </h5>
                                        <button
                                            type="button"
                                            onClick={closePopup}
                                            aria-label="Close"
                                            style={{
                                                width: "40px",
                                                height: "45px",
                                                borderRadius: "4px"
                                            }}
                                        >
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                    </div>
                                    <div className="sugar-salebill-body ">
                                        <form>

                                            <Grid item xs={12} sm={6}>
                                                <TextField
                                                    select
                                                    label="DrCr"
                                                    name="DrCr"
                                                    value={formDataDetail.DrCr || ""}
                                                    onChange={handleChangeDetail}
                                                    variant="outlined"
                                                    size="small"
                                                    sx={{ width: 150, marginRight: '800px' }}
                                                >
                                                    <MenuItem value="C">Credit</MenuItem>
                                                    <MenuItem value="D">Debit</MenuItem>
                                                </TextField>
                                            </Grid>
                                            <div className="SugarSaleBill-row" style={{ marginLeft: '10px' }} >
                                                <label htmlFor="Mill_Name" className="SugarSaleBillLabel" >
                                                    Item Code :
                                                </label>
                                                <div >
                                                    <div >
                                                        <ItemMasterHelp
                                                            onAcCodeClick={handleItemCode}
                                                            CategoryName={item_Name}
                                                            CategoryCode={itemCode}
                                                            SystemType="I"
                                                            name="item_code"
                                                            firstInputRef={firstInputRef}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="SugarSaleBill-row" >
                                                <label htmlFor="Mill_Name" className="SugarSaleBillLabel" >
                                                    Brand Code :
                                                </label>
                                                <div >
                                                    <div >
                                                        <BrandMasterHelp
                                                            onAcCodeClick={handleBrandCode}
                                                            brandName={brand_name}
                                                            brandCode={brand_code}
                                                            name="Brand_Code"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <Grid container spacing={2} className="mt-3">
                                                <Grid item xs={12} sm={6}>
                                                    <TextField
                                                        label="Quantity"
                                                        name="Quantity"
                                                        value={formDataDetail.Quantity}
                                                        onChange={handleChangeDetail}
                                                        fullWidth
                                                        autoComplete="off"
                                                        variant="outlined"
                                                        size="small"
                                                    />
                                                </Grid>
                                                <Grid item xs={12} sm={6}>
                                                    <TextField
                                                        label="Packing"
                                                        name="Packing"
                                                        value={formDataDetail.Packing}
                                                        onChange={handleChangeDetail}
                                                        fullWidth
                                                        autoComplete="off"
                                                        variant="outlined"
                                                        size="small"
                                                    />
                                                </Grid>
                                            </Grid>

                                            <Grid container spacing={2} className="mt-3">
                                                <Grid item xs={12} sm={6}>
                                                    <TextField
                                                        label="NetKg"
                                                        name="Netkg"
                                                        value={formDataDetail.Netkg}
                                                        onChange={handleChangeDetail}
                                                        fullWidth
                                                        autoComplete="off"
                                                        variant="outlined"
                                                        size="small"
                                                        type="number"
                                                        inputProps={{
                                                            step: "0.02",
                                                            min: "0"
                                                        }}
                                                    />
                                                </Grid>


                                                <Grid item xs={12} sm={6}>
                                                    <TextField
                                                        label="Item Amount"
                                                        name="item_Amount"
                                                        value={formDataDetail.item_Amount}
                                                        onChange={handleChangeDetail}
                                                        fullWidth
                                                        autoComplete="off"
                                                        variant="outlined"
                                                        size="small"

                                                    />
                                                </Grid>

                                                <Grid item xs={12} sm={6}>
                                                    <TextField
                                                        label="Narration"
                                                        name="narration"
                                                        value={formDataDetail.narration}
                                                        onChange={handleChangeDetail}
                                                        fullWidth
                                                        autoComplete="off"
                                                        variant="outlined"
                                                        size="small"
                                                    />
                                                </Grid>


                                            </Grid>
                                        </form>
                                    </div>

                                    <div className="modal-footer">
                                        {selectedUser.id ? (
                                            <DetailUpdateButton updateUser={updateUser} />
                                        ) : (
                                            <DetailAddButtom addUser={addUser} />
                                        )}
                                        <DetailCloseButton closePopup={closePopup} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                    <div >

                        <TableContainer component={Paper} className="mt-4" sx={{ width: "70%" }} >
                            <Table aria-label="user table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell sx={headerCellStyle}>Actions</TableCell>
                                        {/* <TableCell sx={headerCellStyle}>RowAction</TableCell> */}
                                        <TableCell sx={headerCellStyle}>ID</TableCell>
                                        <TableCell sx={headerCellStyle}>Item</TableCell>
                                        <TableCell sx={headerCellStyle}>Item Name</TableCell>
                                        <TableCell sx={headerCellStyle}>DrCr</TableCell>
                                        <TableCell sx={headerCellStyle}>Brand Code</TableCell>
                                        <TableCell sx={headerCellStyle}>Brand Name</TableCell>
                                        <TableCell sx={headerCellStyle}>Quantity</TableCell>
                                        <TableCell sx={headerCellStyle}>Packing</TableCell>
                                        <TableCell sx={headerCellStyle}>NetKg</TableCell>
                                        <TableCell sx={headerCellStyle}>Item Amount</TableCell>
                                        {/* <TableCell sx={headerCellStyle}>Rate</TableCell>
                                        <TableCell sx={headerCellStyle}>Item Amount</TableCell>
                                        <TableCell sx={headerCellStyle}>Market Cess</TableCell>
                                        <TableCell sx={headerCellStyle}>DekhRekh</TableCell>
                                        <TableCell sx={headerCellStyle}>Leavy</TableCell>
                                        <TableCell sx={headerCellStyle}>Hamali</TableCell>
                                        <TableCell sx={headerCellStyle}>Tolai</TableCell> */}
                                        {/* <TableCell sx={headerCellStyle}>Saledetailid</TableCell> */}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {users.map((user) => (
                                        <TableRow key={user.id}>
                                            <TableCell sx={{ padding: '0px 1px' }}>
                                                {user.rowaction === "add" || user.rowaction === "update" || user.rowaction === "Normal" ? (
                                                    <>
                                                        <EditButton
                                                            editUser={editUser}
                                                            user={user}
                                                            isEditing={isEditing}
                                                        />
                                                        <DeleteButton
                                                            deleteModeHandler={deleteModeHandler}
                                                            user={user}
                                                            isEditing={isEditing}
                                                        />
                                                    </>
                                                ) : user.rowaction === "DNU" || user.rowaction === "delete" ? (
                                                    <OpenButton openDelete={openDelete} user={user} />
                                                ) : null}
                                            </TableCell>
                                            {/* <TableCell>{user.rowaction}</TableCell> */}
                                            <TableCell sx={{ padding: '0px 1px', textAlign: "center" }}>{user.id}</TableCell>
                                            <TableCell sx={{ padding: '0px 1px', textAlign: "center" }}>{user.item_code}</TableCell>
                                            <TableCell sx={{ padding: '0px 1px', textAlign: "center" }}>{user.item_Name}</TableCell>
                                            <TableCell sx={{ padding: '0px 1px', textAlign: "center" }}>{drCrLabel(user.DrCr)}</TableCell>
                                            <TableCell sx={{ padding: '0px 1px', textAlign: "center" }}>{user.Brand_Code}</TableCell>
                                            <TableCell sx={{ padding: '0px 1px', textAlign: "center" }}>{user.brand_name}</TableCell>
                                            <TableCell sx={{ padding: '0px 1px', textAlign: "center" }}>{user.Quantity}</TableCell>
                                            <TableCell sx={{ padding: '0px 1px', textAlign: "center" }}>{user.Packing}</TableCell>
                                            <TableCell sx={{ padding: '0px 1px', textAlign: "center" }}>{user.Netkg}</TableCell>
                                            <TableCell sx={{ padding: '0px 1px', textAlign: "center" }}>{formatReadableAmount(user.item_Amount)}</TableCell>
                                            {/* <TableCell sx={{ padding: '0px 1px', textAlign: "center" }}>{formatReadableAmount(user.rate)}</TableCell>
                                            <TableCell sx={{ padding: '0px 1px', textAlign: "center" }}>{formatReadableAmount(user.item_Amount)}</TableCell>
                                            <TableCell sx={{ padding: '0px 1px', textAlign: "center" }}>{user.Market_Cess}</TableCell>
                                            <TableCell sx={{ padding: '0px 1px', textAlign: "center" }}>{user.Dekrekh}</TableCell>
                                            <TableCell sx={{ padding: '0px 1px', textAlign: "center" }}>{user.leavy}</TableCell>
                                            <TableCell sx={{ padding: '0px 1px', textAlign: "center" }}>{formatReadableAmount(user.Hamali)}</TableCell>
                                            <TableCell sx={{ padding: '0px 1px', textAlign: "center" }}>{formatReadableAmount(user.Tolai)}</TableCell> */}
                                            {/* <TableCell>{user.saledetailid}</TableCell> */}
                                        </TableRow>
                                    ))}

                                    <TableRow>
                                        <TableCell colSpan={6} sx={{ fontWeight: "bold", textAlign: "right" }}>
                                            Total:
                                        </TableCell>

                                        <TableCell></TableCell>

                                        <TableCell sx={{ fontWeight: "bold", textAlign: "center" }}>
                                            {totalQty.toFixed(2)}
                                        </TableCell>

                                        <TableCell></TableCell>

                                        <TableCell sx={{ fontWeight: "bold", textAlign: "center" }}>
                                            {totalNetwt.toFixed(2)}
                                        </TableCell>

                                        <TableCell sx={{ fontWeight: "bold", textAlign: "center" }}>
                                            {totalamt.toFixed(2)}
                                        </TableCell>
                                        {/* <TableCell></TableCell>
                                        <TableCell sx={{ fontWeight: "bold", textAlign: "center" }}>
                                            {totalamt.toFixed(2)}
                                        </TableCell>
                                        <TableCell sx={{ fontWeight: "bold", textAlign: "center" }}>
                                            {totalMrktcess.toFixed(2)}
                                        </TableCell>
                                        <TableCell sx={{ fontWeight: "bold", textAlign: "center" }}>
                                            {totaldekhRek.toFixed(2)}
                                        </TableCell>
                                        <TableCell sx={{ fontWeight: "bold", textAlign: "center" }}>
                                            {totalleavy.toFixed(2)}
                                        </TableCell>
                                        <TableCell sx={{ fontWeight: "bold", textAlign: "center" }}>
                                            {totalhamali.toFixed(2)}
                                        </TableCell>
                                        <TableCell sx={{ fontWeight: "bold", textAlign: "center" }}>
                                            {totaltolai.toFixed(2)}
                                        </TableCell> */}

                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </div>
                </div>
            </form>
        </>
    );
};
export default GullSaleBillReturn;